import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "../i18n/LanguageProvider";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function NewsletterForm() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    const next = {};
    if (name.trim().length < 2) next.name = t("newsletter.error_name");
    if (!EMAIL_RE.test(email.trim())) next.email = t("newsletter.error_email");
    setErrors(next);
    if (Object.keys(next).length) return;
    setSubmitting(true);
    // Persist locally for the Thank You page (frontend-only)
    try {
      localStorage.setItem(
        "zelorq_last_lead",
        JSON.stringify({
          name: name.trim(),
          email: email.trim(),
          submitted_at: new Date().toISOString(),
        }),
      );
    } catch {}
    navigate("/thank_you");
  };

  return (
    <form
      onSubmit={submit}
      noValidate
      className="bg-white border border-[#E2E8F0] p-6 lg:p-10 rounded-sm shadow-sm"
      data-testid="newsletter-form"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div>
          <label
            htmlFor="lead-name"
            className="block text-xs font-bold tracking-widest uppercase text-slate-600 mb-2"
          >
            {t("newsletter.name_label")}
          </label>
          <input
            id="lead-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder={t("newsletter.name_placeholder")}
            className="w-full h-12 px-4 border border-[#E2E8F0] bg-white text-slate-900 placeholder:text-slate-400 focus:outline-none focus:border-[#0F2537] rounded-sm"
            data-testid="newsletter-name-input"
            aria-invalid={!!errors.name}
            required
          />
          {errors.name && (
            <p
              className="mt-2 text-xs text-[#C85A32]"
              data-testid="newsletter-name-error"
            >
              {errors.name}
            </p>
          )}
        </div>
        <div>
          <label
            htmlFor="lead-email"
            className="block text-xs font-bold tracking-widest uppercase text-slate-600 mb-2"
          >
            {t("newsletter.email_label")}
          </label>
          <input
            id="lead-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t("newsletter.email_placeholder")}
            className="w-full h-12 px-4 border border-[#E2E8F0] bg-white text-slate-900 placeholder:text-slate-400 focus:outline-none focus:border-[#0F2537] rounded-sm"
            data-testid="newsletter-email-input"
            aria-invalid={!!errors.email}
            required
          />
          {errors.email && (
            <p
              className="mt-2 text-xs text-[#C85A32]"
              data-testid="newsletter-email-error"
            >
              {errors.email}
            </p>
          )}
        </div>
      </div>
      <p className="mt-5 text-xs text-slate-500 leading-relaxed">
        {t("newsletter.consent")}
      </p>
      <div className="mt-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <button
          type="submit"
          disabled={submitting}
          className="inline-flex items-center justify-center h-12 px-6 bg-[#C85A32] hover:bg-[#b04d28] disabled:opacity-70 text-white font-semibold text-sm tracking-wide rounded-sm"
          data-testid="newsletter-submit"
        >
          {submitting ? t("newsletter.submitting") : t("newsletter.submit")}
        </button>
        <span className="text-xs text-slate-500">
          {t("newsletter.delivery_note")}
        </span>
      </div>
    </form>
  );
}
